export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10077.804351fa.jpg";